export default __webpack_public_path__ + "static/media/avatar_koala8.57e34441.mp3";